import type { InputController } from "../game/input";

interface Props {
  input: InputController;
}

/**
 * On-screen controls for touch devices. Hidden on hover-capable input devices.
 * Uses pointer events so it works for mouse, pen, and touch consistently.
 */
export function TouchControls({ input }: Props) {
  const onDuckStart = (e: React.PointerEvent) => {
    (e.target as Element).setPointerCapture(e.pointerId);
    input.trigger("duck", true);
  };
  const onDuckEnd = (e: React.PointerEvent) => {
    try {
      (e.target as Element).releasePointerCapture(e.pointerId);
    } catch {
      // ignore
    }
    input.trigger("duck", false);
  };

  return (
    <div
      className="pointer-events-none absolute inset-x-0 bottom-3 z-20 grid grid-cols-3 gap-3 px-3 sm:hidden"
      aria-hidden="false"
    >
      <ControlButton
        label="Jump"
        accent="bg-cap-red"
        onPointerDown={(e) => {
          e.preventDefault();
          input.trigger("jump");
        }}
      />
      <ControlButton
        label="Duck"
        accent="bg-cap-blue"
        onPointerDown={onDuckStart}
        onPointerUp={onDuckEnd}
        onPointerCancel={onDuckEnd}
        onPointerLeave={onDuckEnd}
      />
      <ControlButton
        label="Throw"
        accent="bg-cap-gold text-cap-deep"
        onPointerDown={(e) => {
          e.preventDefault();
          input.trigger("throw");
        }}
      />
    </div>
  );
}

function ControlButton(props: {
  label: string;
  accent: string;
} & React.HTMLAttributes<HTMLButtonElement>) {
  const { label, accent, className, ...rest } = props;
  return (
    <button
      {...rest}
      className={[
        "pointer-events-auto touch-none select-none rounded-2xl border border-white/20 px-3 py-4",
        "font-display text-base uppercase tracking-widest shadow-lg",
        "active:scale-95 transition-transform text-white",
        accent,
        className ?? "",
      ].join(" ")}
    >
      {label}
    </button>
  );
}
